import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "./Modal.scss";
import {
  cnpj_mask,
  updateTableNew,
  updateTableNewWithParams,
} from "../../services/Servicos";
import { getErrorMessage, telefoneMask } from "../../services/helpers";
import ModalErrorPretty from "./ModalErrorPretty";
import BotaoSalvar from "../botoes/BotaoSalvar";

export default function ModalEditarRowTransportadora(props) {
  const user = useSelector((state) => state.userSlice);
  const handlerSimpleClose = () => props.setShow((last) => ({ show: false }));

  const [body, setBody] = useState(props.body);
  const [btn, setBtn] = useState({
    flag: false,
    style: "primary",
    msg: "Salvar",
  });

  const [error, setError] = useState({ show: false, message: "" });

  const submit = async () => {
    setBtn({
      flag: true,
      msg: "Carregando",
      style: "warning",
    });
    try {
      await updateTableNewWithParams("transportadoras", props.body.id, body);
      setBtn({
        flag: true,
        msg: "Concluído",
        style: "success",
      });
      setTimeout(() => {
        handlerSimpleClose();
      }, 1000);
    } catch (error) {
      setError({
        show: true,
        message: getErrorMessage(error),
      });
      setBtn({
        flag: false,
        msg: "Salvar",
        style: "primary",
      });
    }
  };

  const onChangeInput = (e) => {
    if (e.target.name === "cnpj") {
      setBody((last) => ({
        ...last,
        [e.target.name]: cnpj_mask(e.target.value),
      }));
      return;
    }
    if (e.target.name === "telefone") {
      setBody((last) => ({
        ...last,
        [e.target.name]: telefoneMask(e.target.value),
      }));
      return;
    }
    if (e.target.name === "email") {
      setBody((last) => ({
        ...last,
        [e.target.name]: e.target.value,
      }));
      return;
    }
    setBody((last) => ({
      ...last,
      [e.target.name]: e.target.value.toUpperCase(),
    }));
  };

const onSubmit = (e) => {
    e.preventDefault();
    submit();
};

return (
    <>
        <Modal
            show={props.show}
            onHide={handlerSimpleClose}
            backdrop="static"
            keyboard={false}
            centered
            size="md"
        >
            <Modal.Header closeButton>
                <Modal.Title>Editar Transportadora</Modal.Title> 
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Row className="mb-2">
                        <Col sm="4">
                            <Form.Label>Razão Social:</Form.Label>
                        </Col>
                        <Col>
                            <Form.Control
                                type="text"
                                name="razao_social"
                                onChange={onChangeInput}
                                value={body?.razao_social || ""}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="4">
                            <Form.Label>Nome Fantasia:</Form.Label>
                        </Col>
                        <Col>
                            <Form.Control
                                type="text"
                                name="nome_fantasia"
                                onChange={onChangeInput}
                                value={body?.nome_fantasia || ""}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="4">
                            <Form.Label>CNPJ:</Form.Label>
                        </Col>
                        <Col>
                            <Form.Control
                                type="text"
                                name="cnpj"
                                value={body?.cnpj || ""}
                                disabled
                                maxLength={18}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="4">
                            <Form.Label>Inscrição Estadual:</Form.Label>
                        </Col>
                        <Col>
                            <Form.Control
                                type="text"
                                name="inscricao_estadual"
                                onChange={onChangeInput}
                                value={body?.inscricao_estadual || ""}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="4">
                            <Form.Label>Endereço:</Form.Label>
                        </Col>
                        <Col>
                            <Form.Control
                                type="text"
                                name="endereco"
                                onChange={onChangeInput}
                                value={body?.endereco || ""}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="4">
                            <Form.Label>E-mail:</Form.Label>
                        </Col>
                        <Col>
                            <Form.Control
                                type="email"
                                name="email"
                                onChange={onChangeInput}
                                value={body?.email || ""}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="4">
                            <Form.Label>Telefone:</Form.Label>
                        </Col>
                        <Col>
                            <Form.Control
                                type="text"
                                name="telefone"
                                onChange={onChangeInput}
                                value={body?.telefone || ""}
                                maxLength={15}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="4">
                            <Form.Label>RNTRC:</Form.Label>
                        </Col>
                        <Col>
                            <Form.Control
                                type="text"
                                name="rntrc"
                                onChange={onChangeInput}
                                value={body?.rntrc || ""}
                            />
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <div style={{ minWidth: "150px" }}>
                    <BotaoSalvar msg={btn.msg} style={btn.style} fnRetorno={submit} />
                </div>
                <div style={{ minWidth: "150px" }}>
                    <Button variant="secondary" onClick={handlerSimpleClose}>
                        Fechar
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
        {error.show ? <ModalErrorPretty {...error} setShow={setError} /> : ""}
    </>
);
}
